





























































































































































































































































import { Component, Emit, Prop, PropSync } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import {
  alertStore,
  dataStore,
  modalErrorStore,
  systemCodeStore,
  systemParameterStore
} from '@/utils/store-accessor'
import {
  AlertMessage,
  defaultSystemCode,
  ErrorMessage,
  SystemCode,
  userApi
} from '@/api'
import { InputCode } from '@/components/molecules/InputCode'
import { UserDetailStateInfo, UserStatus } from '@/types'
import { dateToPlainFormat } from '@/utils'
import { InputUserId } from '@/components/molecules/InputUserId'

export interface UserDetailUserInfoItem {
  userId: {
    input: string
    errorMessage: string
  }
  userType: {
    input: string
    display: string
    errorMessage: string
  }
  workType: SystemCode
  name: {
    input: string
    errorMessage: string
  }
  expirationDate: {
    input: string
    errorMessage: string
  }
  nameKana: {
    input: string
    errorMessage: string
  }
  userStatus: {
    input: SystemCode
    errorMessage: string
  }
  studentGrade: {
    input: string
    display: string
    errorMessage: string
  }
  studentClass: {
    input: string
    display: string
    errorMessage: string
  }
  studentNumber: {
    input: string
    errorMessage: string
  }
}

export const defaultUserDetailUserInfoItem = (): UserDetailUserInfoItem => ({
  userId: {
    input: '',
    errorMessage: ''
  },
  userType: {
    input: '',
    display: '',
    errorMessage: ''
  },
  workType: defaultSystemCode(),
  name: {
    input: '',
    errorMessage: ''
  },
  expirationDate: {
    input: '',
    errorMessage: ''
  },
  nameKana: {
    input: '',
    errorMessage: ''
  },
  userStatus: {
    input: defaultSystemCode(),
    errorMessage: ''
  },
  studentGrade: {
    input: '',
    display: '',
    errorMessage: ''
  },
  studentClass: {
    input: '',
    display: '',
    errorMessage: ''
  },
  studentNumber: {
    input: '',
    errorMessage: ''
  }
})

@Component({
  components: {
    InputUserId,
    InputCode
  }
})
export default class UserDetailUserInfo extends ComponentVue {
  @PropSync('item', {
    type: Object,
    required: true
  })
  inputItem!: UserDetailUserInfoItem

  @Prop({
    type: Object,
    required: true
  })
  state!: UserDetailStateInfo

  @Prop({
    type: Boolean,
    default: false
  })
  userIdReadOnly!: boolean

  @Prop({
    type: Boolean,
    default: false
  })
  hideUserSearch!: boolean

  @Prop({
    type: Boolean,
    default: false
  })
  displayWorkType!: boolean

  get displayUserType(): string {
    if (this.displayWorkType && this.inputItem.workType.shortName !== '') {
      return (
        this.inputItem.userType.display +
        `（${this.inputItem.workType.shortName}）`
      )
    }

    return this.inputItem.userType.display
  }

  get userStatusItems(): SystemCode[] {
    return systemCodeStore.getUserStatus
  }

  get nameIsRequired() {
    return this.state.isCreateOrUpdate()
      ? systemParameterStore.isRequireUserName
      : false
  }

  get nameKanaIsRequired() {
    return this.state.isCreateOrUpdate()
      ? systemParameterStore.isRequireUserNameKana
      : false
  }

  get userIcon(): string {
    return this.state.isGroup() ? 'users' : 'male'
  }

  get userIconState(): string {
    return this.inputItem.userStatus.input.code === UserStatus.Enabled
      ? 'male'
      : 'invalid'
  }

  get enabledSchool(): boolean {
    return dataStore.enabledSchool
  }

  async updateExpirationDate() {
    try {
      this.inputItem.expirationDate.input = dateToPlainFormat(
        await userApi.getUserNewExpirationDate({
          userType: this.inputItem.userType.input,
          expirationDate: this.inputItem.expirationDate.input,
          _create: this.state.isCreate()
        })
      )

      if (dataStore.isResetCardLostCountOnUserExpirationUpdate) {
        this.$emit('updated:expiration-date')
      }
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    }
  }

  existsErrorMessage(errorMessage: string): boolean {
    return !!errorMessage
  }

  resetErrorMessage(obj: any): void {
    obj.errorMessage = ''
  }

  onDetermineUserId(): void {
    if (!this.state.isCreateOrUpdate()) {
      this.callUserSearch(this.inputItem.userId.input)
    }
  }

  @Emit('click:user-search')
  onClickUserSearch(): void {}

  @Emit('call:user-search')
  callUserSearch(id: string): string {
    return id
  }
}
